import { useLocation, useNavigate } from 'react-router-dom';
import {
    ACTIVITY_LOG_PATH,
    DASHBOARD_PATH,
    DEVICES_PATH,
    USERS_PATH,
} from '../../../router/RouteConstants';
import styles from './SideMenu.module.css';
import { useIntl } from 'react-intl';
import { useContext, useEffect } from 'react';
import { Context } from '../../../context/Context';
import DashboardIcon from '../../../assets/images/dashboard_Icon.png';
import UsersIcon from '../../../assets/images/users_icon.png';
import DevicesIcon from '../../../assets/images/devices_icon.png';
import ActivityLogIcon from '../../../assets/images/activity_log_icon.png';
import DashboardLightIcon from '../../../assets/images/dashboard_light_icon.svg';
import UserLightIcon from '../../../assets/images/users_light_icon.svg';
import DevicesLightIcon from '../../../assets/images/devices_light_icon.svg';
import ActivityLogLightIcon from '../../../assets/images/activity_log_light_icon.svg';

const SideMenu = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const navigate = useNavigate();
    const location = useLocation();

    const { sideMenuCurrentActive, setSideMenuCurrentActive, triggerRefresh } =
        useContext(Context);

    const sideMenu = [
        {
            header: f({ id: 'AI_EDU_DASHBOARD' }),
            key: 'dashboard',
            link: DASHBOARD_PATH,
            imageSrc: DashboardIcon,
            imageLight: DashboardLightIcon,
        },
        {
            header: f({ id: 'AI_EDU_USERS' }),
            key: 'user',
            link: USERS_PATH,
            imageSrc: UsersIcon,
            imageLight: UserLightIcon,
        },
        {
            header: f({ id: 'AI_EDU_DEVICES' }),
            key: 'device',
            link: DEVICES_PATH,
            imageSrc: DevicesIcon,
            imageLight: DevicesLightIcon,
        },
        {
            header: f({ id: 'AI_EDU_ACTIVITY_LOG' }),
            key: 'activity',
            link: ACTIVITY_LOG_PATH,
            imageSrc: ActivityLogIcon,
            imageLight: ActivityLogLightIcon,
        },
    ];

    useEffect(() => {
        switch (location.pathname) {
            case DASHBOARD_PATH:
                setSideMenuCurrentActive(0);
                break;
            case USERS_PATH:
                setSideMenuCurrentActive(1);
                break;
            case DEVICES_PATH:
                setSideMenuCurrentActive(2);
                break;
            case ACTIVITY_LOG_PATH:
                setSideMenuCurrentActive(3);
                break;
            default:
                break;
        }
    }, [location.pathname]);

    const handleSideMenuItemClick = (key, link) => {
        triggerRefresh(key);
        navigate(link);
    };

    return (
        <div className={styles.side_panel}>
            {sideMenu.map((item, index) => (
                <div
                    className={`${styles.side_panel_item}  ${
                        sideMenuCurrentActive === index
                            ? `${styles.active_side_bar}`
                            : ''
                    }`}
                    onClick={() => handleSideMenuItemClick(item.key, item.link)}
                    key={index}
                >
                    <span className={styles.item_icon}>
                        <img
                            src={
                                sideMenuCurrentActive === index
                                    ? item.imageLight
                                    : item.imageSrc
                            }
                        />
                    </span>
                    <span>{item.header}</span>
                </div>
            ))}
        </div>
    );
};

export default SideMenu;
